import MentorStats, { MentorStatsType } from 'components/MentorStats';
import ProfileNavigation from 'components/profileNavigation';
import ProfileLink from 'components/profileNavigation/Link';
import {
  mentorActionRequiredStatus,
  MentorshipStatusValues,
} from 'enums/MentorshipStatus';
import { MentorshipManagementContext } from 'pages/mentor/mentorship/management';
import { FC, useContext, useMemo } from 'react';
import useSWR from 'swr';
import MentorshipMenteeManagementRoutes from './Routes';

const baseURL = '/mentor/mentorship/management/mentees/';
const Mentees: FC = () => {
  const { data } = useSWR<MentorStatsType>('/mentorship/mentor/stats');
  const { mentorships } = useContext(MentorshipManagementContext);

  const requiredActions: number = useMemo(() => {
    return (
      mentorships?.filter((mentorship) =>
        mentorActionRequiredStatus.includes(
          mentorship.status as MentorshipStatusValues,
        ),
      ).length || 0
    );
  }, [mentorships]);

  return (
    <section>
      <MentorStats
        {...{
          ...(data || {
            wantedMentorship: undefined,
            assignedMentorship: undefined,
            finishedMentorship: undefined,
            lateMentorship: undefined,
            interruptedMentorship: undefined,
          }),
        }}
      />
      <ProfileNavigation>
        <ProfileLink to={baseURL}>
          Mentorats en cours
          {!!requiredActions && <div>{requiredActions} </div>}
        </ProfileLink>
        <ProfileLink to={baseURL + 'history'}>Historique</ProfileLink>
      </ProfileNavigation>
      <MentorshipMenteeManagementRoutes />
    </section>
  );
};

export default Mentees;
